import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTriggeringDetailsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastTriggeringDetailsRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastTriggeringDetailsRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/triggering_details',
)({
  component: BroadcastTriggeringDetailsRoute,
});
